import { Navigate, Outlet, useLocation } from 'react-router-dom';

import { useMainstreamCountries } from '@/hooks/queries/use-mainstream-countries';
import { useProfileInstitutionDetailsAnswers } from '@/hooks/queries/use-profile-institution-details';
import { isJurisdictionPermitted } from '@/utils';

type IneligibilityReason = 'CORPORATION_JURISDICTION' | 'BRANCH_OPERATIONS_JURISDICTION';

const INELIGIBLE_PATHS = {
  CORPORATION_JURISDICTION: (jurisdiction: string) => `/institution/onboarding/incorporation/forbidden-jurisdiction/${jurisdiction}`,
  BRANCH_OPERATIONS_JURISDICTION: (jurisdiction: string) => `/institution/onboarding/branch-operations/forbidden-jurisdiction/${jurisdiction}`,
} as const satisfies Record<IneligibilityReason, unknown>;

const InstitutionOnboardingEligibilityGuard = () => {
  const { data: countries } = useMainstreamCountries();
  const { data: institutionDetailsAnswers } = useProfileInstitutionDetailsAnswers();
  const location = useLocation();
  const countryOfIncorporation = institutionDetailsAnswers?.incorporation?.countryOfIncorporation;
  const countryOfBranchOperations = institutionDetailsAnswers?.branchOperations?.countryOfBranchOperations;

  if (
    countryOfIncorporation &&
    countries &&
    !isJurisdictionPermitted(countryOfIncorporation, countries) &&
    location.pathname !== INELIGIBLE_PATHS.CORPORATION_JURISDICTION(countryOfIncorporation)
  ) {
    return <Navigate to={INELIGIBLE_PATHS.CORPORATION_JURISDICTION(countryOfIncorporation)} replace />;
  }

  if (
    countryOfBranchOperations &&
    countries &&
    !isJurisdictionPermitted(countryOfBranchOperations, countries) &&
    location.pathname !== INELIGIBLE_PATHS.BRANCH_OPERATIONS_JURISDICTION(countryOfBranchOperations)
  ) {
    return <Navigate to={INELIGIBLE_PATHS.BRANCH_OPERATIONS_JURISDICTION(countryOfBranchOperations)} replace />;
  }

  return <Outlet />;
};
InstitutionOnboardingEligibilityGuard.displayName = 'InstitutionOnboardingEligibilityGuard';

export default InstitutionOnboardingEligibilityGuard;
